import React from "react";
import { BookOpenIcon } from "lucide-react";
import { volumes } from "../../data/volumes";
export function CategoryGrid() {
  return <ul className="grid grid-flow-col grid-cols-2 grid-rows-3 gap-x-3 gap-y-3 sm:gap-x-6" data-id="element-168" data-mp="senxi7q68bii">
      {volumes.map(v => <li key={v.number} className="flex items-start gap-2 text-[14px] leading-snug text-ink sm:text-[15px]" data-id="element-169" data-mp="dogmue6enwsd">
          <BookOpenIcon className="mt-0.5 h-[18px] w-[18px] shrink-0 text-rose" strokeWidth={1.5} aria-hidden="true" data-id="element-170" data-mp="4pmjm4ykk85u" />
          <span data-id="element-171" data-mp="9p8wueeedoen">
            <strong className="mr-1 font-bold text-wine" data-id="element-172" data-mp="9pqzbsrnkyv0">Vol. {v.number}</strong>
            {v.title}
            {v.count !== undefined && <span className="text-muted" data-id="element-173" data-mp="3qynrcad2kd42"> · {v.count} ricette</span>}
          </span>
        </li>)}
    </ul>;
}